class BackToTop extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.target = document.createElement("div");
    this.target.classList.add("back-to-top-target");
    document.body.append(this.target);

    this.observer = new IntersectionObserver((entries) => {
      this.toggleAttribute("show", !entries[0].isIntersecting);
    });

    this.observer.observe(this.target);

    this.button = this.querySelector("button");

    this.button.addEventListener("click", () => {
      this.button.blur();
      window.scroll({ top: 0, behavior: "smooth" });
    });
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.target.remove();
    this.removeAttribute("show");
  }
}

if (!customElements.get("back-to-top")) {
  customElements.define("back-to-top", BackToTop);
}
